import React from 'react';

import { WarningContainer, WarningInfoIcon, WarningMessageContainer, WarningText } from './styled';

export const InfoBox: React.FC<{ warning: string; info: string }> = ({ warning, info }) => {
  return (
    <>
      <WarningContainer>
        <WarningInfoIcon
          data-testid="block-warning-info-icon"
          icon="info"
          color="icon-default"
          width="24px"
        />
        <WarningMessageContainer>
          <WarningText data-testid="block-warning-msg" aria-label={warning}>
            {warning}
          </WarningText>
          <WarningText data-testid="block-warning-info-msg" aria-label={info}>
            {info}
          </WarningText>
        </WarningMessageContainer>
      </WarningContainer>
    </>
  );
};
